import React, {useEffect, useState} from "react";
import { Styles } from "./styles";
import {
  Autocomplete,
  Box, Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import LeftBlue from "../../../Assets/Svg/OurServiceSvg/LeftBlue.svg";
import RightBlue from "../../../Assets/Svg/OurServiceSvg/RightBlue.svg";
import LeftOrange from "../../../Assets/Svg/OurServiceSvg/LeftOrange.svg";
import RightOrange from "../../../Assets/Svg/OurServiceSvg/RightOrange.svg";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
const MainData = (props) => {
  const [errorText, setErrorText] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");








  // const validateUrl = (value) => {
  //   if (value.trim() === "") {
  //     // Reset error state if the input is empty
  //     setError(false);
  //     setHelperText("");
  //     return;
  //   }

  //   const urlPattern =
  //     /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]{2,}\.[a-z]{2,}(\.[a-z]{2,})?$/;
  //   if (!urlPattern.test(value)) {
  //     setError(true);
  //     setHelperText("Please enter a valid URL (e.g., https://example.com)");
  //   } else {
  //     setError(false);
  //     setHelperText("");
  //   }
  // };
  const {
    selectedCategories,
    handleCategoryChange,
    selectedSubcategoryDetails,
    handleSubcategoryChange,
    selectedSubcategory,
    Categories,
    selectedCategoryDetails,
    handleChange,
    formData,
    selectedGroups,
    setSelectedGroups,
  } = props;


  const [groupOptions, setGroupOptions] = useState([]);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);

  useEffect(() => {

    const pricePerItem =selectedCategories === 48 ?
        formData.recipient_type === 'all_users' ? selectedCategoryDetails?.max_unit_price ?? 0 : selectedCategoryDetails?.min_unit_price ?? 0
        : selectedCategoryDetails?.unit_price ?? 0;
    const total = selectedGroups.reduce((sum, group) => {
      return sum + (group.count * pricePerItem);
    }, 0);
    setBasePrice(total *selectedSubcategoryDetails?.days / 30);

    let finalPrice = total;


    setCalculatedPrice(finalPrice);
  }, [selectedGroups, selectedCategoryDetails,selectedSubcategoryDetails]);


  const handleGroupSelection = (event, newValue) => {
    setSelectedGroups(newValue);
  };

  useEffect(() => {
    if (selectedCategoryDetails) {
      const allGroups =
          selectedCategoryDetails.groups ? selectedCategoryDetails.groups.map(group => ({
            ...group,
            serviceId: selectedCategoryDetails.id,
            serviceTitle: selectedCategoryDetails.name
          })) : []

      setGroupOptions(allGroups);
    }
    else{
      const allGroups = Categories.flatMap(category =>
          category.groups ? category.groups.map(group => ({
            ...group,
            serviceId: category.id,
            serviceTitle: category.name
          })) : []
      );
      setGroupOptions(allGroups);
    }
  }, [Categories,selectedCategoryDetails]);

  return (
    <Styles>
      <Box className="main-data-container">
        <Box className="form-data">
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={11}
              sx={{ paddingInlineStart: "0px !important",marginBottom:'15px' }}
            >
              <FormControl
                fullWidth
                variant="outlined"
                sx={{
                  boxShadow: "1px 2px 4px #454040",
                  borderRadius: "8px",
                  background: "#F5F8FE",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      borderColor: "#4ea27d",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#4ea27d",
                    },
                  },
                }}
              >
                <InputLabel
                  id="select-category-label"
                  sx={{
                    color: "#474747",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "20px",
                    "&.Mui-focused": {
                      color: "#4ea27d",
                    },
                  }}
                >
                  Service *
                </InputLabel>
                <Select
                  labelId="select-category-label"
                  id="select-category"
                  value={selectedCategories}
                  onChange={(e) => {
                    handleCategoryChange(e?.target?.value);
                  }}
                  displayEmpty
                  label="Select Category"
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "10px 12px",

                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiSelect-icon": {
                      color: "#707275",
                    },
                    "& .MuiMenu-paper": {
                      maxHeight: "200px",
                      backgroundColor: "#f5f8fe",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      "& .MuiMenuItem-root": {
                        padding: "10px",
                        color: "#333",
                        fontSize: "14px",
                        borderBottom: "1px solid #9E9E9E",
                        '&[aria-selected="true"]': {
                          backgroundColor: "#4ea27d",
                          color: "#fff",
                        },
                        '&[data-focus="true"]': {
                          backgroundColor: "#4ea27d",
                        },
                      },
                    },
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#F5F8FE",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#2d5644",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#2d5644",
                    },
                  }}
                  inputProps={{
                    "aria-label": "Select Category",
                  }}
                >
                  {/* Replace Categories with your actual category data array */}
                  {Categories.map((option) => (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                      sx={{
                        padding: "10px",
                        color: "#333",
                        fontSize: "14px",
                        borderBottom: "1px solid #9E9E9E",
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {selectedCategoryDetails?.with_type &&
            <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important",marginBottom:'15px'  }}
            >
              <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{
                    boxShadow: "1px 2px 4px #454040",
                    borderRadius: "8px",
                    background: "#F5F8FE",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        borderColor: "#4ea27d",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#4ea27d",
                      },
                    },
                  }}
              >
                <InputLabel
                    id="select-subcategory-label"
                    sx={{
                      color: "#474747",
                      fontSize: "16px",
                      fontWeight: "500",
                      lineHeight: "20px",
                      "&.Mui-focused": {
                        color: "#4ea27d",
                      },
                    }}
                >
                  Type *
                </InputLabel>
                <Select
                    labelId="select-subcategory-label"
                    id="select-subcategory"
                    value={selectedSubcategory}
                    onChange={(e) => {
                      handleSubcategoryChange(e?.target?.value);
                    }}
                    displayEmpty
                    label="Select Subcategories"
                    sx={{
                      "& .MuiSelect-select": {
                        padding: "10px 12px",

                        display: "flex",
                        alignItems: "center",
                        justifyContent:'space-between',
                      },
                      "& .MuiSelect-icon": {
                        color: "#707275",
                      },
                      "& .MuiMenu-paper": {
                        maxHeight: "200px",

                        backgroundColor: "#f5f8fe",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        "& .MuiMenuItem-root": {
                          padding: "10px",
                          color: "#333",
                          fontSize: "14px",
                          borderBottom: "1px solid #9E9E9E",
                          '&[aria-selected="true"]': {
                            backgroundColor: "#4ea27d",
                            color: "#fff",
                          },
                          '&[data-focus="true"]': {
                            backgroundColor: "#4ea27d",
                          },
                        },
                      },
                      "&::-webkit-scrollbar": {
                        width: "8px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#F5F8FE",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#2d5644",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#2d5644",
                      },
                    }}
                >
                  {/* Replace getSubCategories() with your actual function or array */}
                  {selectedCategoryDetails &&
                  selectedCategoryDetails.subCategories.map((option) => (
                      <MenuItem
                          key={option.id}
                          value={option.id}
                          sx={{
                            padding: "10px",
                            color: "#333",
                            fontSize: "14px",
                            borderBottom: "1px solid #9E9E9E",
                            justifyContent: "space-between",
                          }}
                      >
                        <Typography>{option.label}</Typography>
                        <Typography>{option.price}$</Typography>
                      </MenuItem>
                  ))}
                  {/* {getSubCategories().map((option) => (
                                      <MenuItem
                                          key={option.id}
                                          value={option.id}
                                          sx={{
                                              padding: '10px',
                                              color: '#333',
                                              fontSize: '14px',
                                              borderBottom: '1px solid #9E9E9E',
                                          }}
                                      >
                                          {option.label}
                                      </MenuItem>
                                  ))} */}
                </Select>
              </FormControl>
            </Grid>
            }


            <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important" }}
            >
              <TextField
                  fullWidth
                  rows={5}
                  multiline
                  minRows={1}
                  readOnly
                  variant="outlined"
                  InputLabelProps={{
                    style: {
                      color: "#434343",
                      fontSize: "13px",
                      padding: "5px",
                    },
                  }}
                  value={selectedCategoryDetails?.description}
                  onChange={null}
                  name="title"
                  placeholder="Type Title"
                  InputProps={{
                    readOnly: true, // Makes the TextField read-only
                  }}
                  sx={{
                    background: "white",
                    borderRadius: "8px",
                    "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "10px",
                        },
                    "& .MuiOutlinedInput-root": {
                      border: "1px solid #5F5F5F",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "8px",
                      "& fieldset": {
                        border: "none",
                      },
                    },
                  }}
              />
            </Grid>

            {selectedCategoryDetails?.with_groups && (
              <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important" }}
              >
                <Box
                    sx={{
                      borderBottom: "2px solid #80808050",
                      paddingBlock: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                >
                  {
                    groupOptions.length > 0 &&
                    <Autocomplete
                        multiple
                        options={groupOptions}
                        getOptionLabel={(option) => `${option.name}  - ${option.count} items`}
                        value={selectedGroups}
                        onChange={handleGroupSelection}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Groups &"
                                placeholder="Choose groups to subscribe *"
                            />
                        )}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox checked={selected} />
                              {option.name} - {option.count} items
                            </li>
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        sx={{ width: '100%' }}
                    />
                  }


                  {selectedGroups.length > 0 && (
                      <Box mt={2}>
                        <Typography variant="body2">
                          Selected Groups: {selectedGroups.length}
                        </Typography>
                        <Typography variant="body2">
                          Total Items: {selectedGroups.reduce((sum, group) => sum + group.count, 0)}
                        </Typography>
                      </Box>
                  )}
                </Box>
              </Grid>
            )}

            {selectedCategoryDetails?.FiledTitle && (
              <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important" }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: {
                      color: "#434343",
                      fontSize: "13px",
                      padding: "5px",
                    },
                  }}
                  value={formData.title}
                  onChange={(e) => handleChange("title", e.target.value)}
                  name="title"
                  placeholder="Type Title *"
                  sx={{
                    background: "white",
                    borderRadius: "8px",
                    "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input":
                      {
                        padding: "10px",
                      },
                    "& .MuiOutlinedInput-root": {
                      border: "1px solid #5F5F5F",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "8px",
                      "& fieldset": {
                        border: "none",
                      },
                    },
                  }}
                />
              </Grid>
            )}

            {selectedCategoryDetails?.FiledDescription && (
              <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important" }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={1}
                  InputLabelProps={{
                    style: { color: "#434343", fontSize: "13px" },
                  }}
                  value={formData.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  name="description"
                  placeholder="Add your description here... *"
                  sx={{
                    background: "white",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      border: "1px solid #5F5F5F",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "8px",
                      "& fieldset": {
                        border: "none",
                      },
                      "& textarea": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
            )}

            {selectedCategoryDetails?.FiledPanel &&(
            <Grid
                item
                xs={12}
                sm={12}
                md={11}
                sx={{ paddingInlineStart: "0px !important" }}
            >
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: {
                      color: "#434343",
                      fontSize: "13px",
                      padding: "5px",
                    },
                  }}
                  value={formData.panel_url}
                  onChange={(e) => {
                    const url = e.target.value;
                    handleChange("panel_url", url);
                  }}
                  name="panel_url"
                  placeholder="Put your Link here (e.g., https://example.com) *"
                  sx={{
                    background: "white",
                    borderRadius: "8px",
                    "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                      padding: "10px",
                    },
                    "& .MuiOutlinedInput-root": {
                      border: "1px solid #5F5F5F",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "8px",
                      "& fieldset": {
                        border: "none",
                      },
                    },
                  }}
              />
            </Grid>
            )}

            {/*// In MainData component, add this after the existing form fields*/}
            {selectedCategories === 48 && (
                <Grid
              item
              xs={12}
              sm={12}
              md={11}
              sx={{ paddingInlineStart: "0px !important" }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>Bulk Email Configuration *</Typography>

                  {/* Recipient Type Selection */}
                  <FormControl component="fieldset" sx={{ mb: 3 }}>
                    <FormLabel component="legend">Choose Recipients *</FormLabel>
                    <RadioGroup
                        value={formData.recipient_type || 'custom_emails'}
                        onChange={(e) => handleChange('recipient_type', e.target.value)}
                    >
                      <FormControlLabel
                          value="all_users"
                          control={<Radio />}
                          label="System Users"
                      />
                      <FormControlLabel
                          value="custom_emails"
                          control={<Radio />}
                          label="Custom Emails (comma separated)"
                      />
                      <FormControlLabel
                          value="excel_file"
                          control={<Radio />}
                          label="Upload Excel File"
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Custom Emails Textarea */}
                  {formData.recipient_type === 'custom_emails' && (
                      <TextField
                          fullWidth
                          multiline
                          rows={4}
                          label="Email Addresses"
                          placeholder="Enter email addresses separated by commas"
                          value={formData.custom_emails || ''}
                          onChange={(e) => handleChange('custom_emails', e.target.value)}
                          sx={{ mb: 2 }}
                          helperText="Enter email addresses separated by commas (e.g., email1@example.com, email2@example.com)"
                      />
                  )}

                  {/* Excel File Upload */}
                  {formData.recipient_type === 'excel_file' && (
                      <Box sx={{ mb: 2 }}>
                        <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => handleChange('excel_file', e.target.files[0])}
                        />
                        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Upload Excel file with email addresses in the first column (csv file)
                        </Typography>
                      </Box>
                  )}

                  {/* Email Subject */}
                  <TextField
                      fullWidth
                      label="Email Subject *"
                      value={formData.subject || ''}
                      onChange={(e) => handleChange('subject', e.target.value)}
                      sx={{ mb: 2 }}
                      required
                  />

                  {/* Email Message */}
                  <TextField
                      fullWidth
                      multiline
                      rows={6}
                      label="Email Message *"
                      value={formData.message || ''}
                      onChange={(e) => handleChange('message', e.target.value)}
                      sx={{ mb: 2 }}
                      required
                      helperText="You can use HTML for formatting"
                  />
                </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={12}
              md={11}
              sx={{ paddingInlineStart: "0px !important" }}
            >
              {
                selectedCategoryDetails?.id === 47 ?
                    <label htmlFor={'countTicket'}>Hours</label>   :
                    <label htmlFor={'countTicket'}>{selectedCategoryDetails?.with_type ? "Days *" : "count Ticket *"}</label>
              }

              <TextField
                fullWidth
                variant="outlined"
                type={'number'}

                InputLabelProps={{
                  style: {
                    color: "#434343",
                    fontSize: "13px",
                    padding: "5px",
                  },
                }}
                value={selectedCategoryDetails?.with_type ?selectedSubcategoryDetails?.days :formData?.countTicket}
                onChange={(e) => handleChange("countTicket", e.target.value)}
                name="countTicket"
                placeholder="*"
                InputProps={{
                  readOnly: selectedCategoryDetails?.with_type ? true :false, // Makes the TextField read-only
                }}
                sx={{
                  background: "white",
                  borderRadius: "8px",
                  "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                    padding: "10px",
                  },
                  "& .MuiOutlinedInput-root": {
                    border: "1px solid #5F5F5F",
                    boxShadow: "-2px 2px 4px #00000040",
                    borderRadius: "8px",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
              <FormHelperText sx={{
                mt: 1,
                fontSize: '12px',
                color: '#5F5F5F',
                textAlign: 'right', // Align right (optional)
              }}>
                {selectedCategoryDetails?.with_type
                    ? "" // Hide hint if read-only (optional)
                    : `Minimum: ${selectedCategoryDetails?.min_count}, Maximum: ${selectedCategoryDetails?.max_count}`
                }
              </FormHelperText>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={11}
              sx={{ paddingInlineStart: "0px !important" }}
            >
              <label for={'price'}>Price</label>
              <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  style: {
                    color: "#434343",
                    fontSize: "13px",
                    padding: "5px",
                  },
                }}
                value={
                  selectedCategoryDetails?.with_groups ?
                      basePrice :
                  (selectedCategoryDetails?.with_type ?
                    selectedSubcategoryDetails?.price :
                    parseFloat((selectedCategories === 48 ?
                        formData.recipient_type === 'all_users' ? selectedCategoryDetails?.max_unit_price ?? 0 : selectedCategoryDetails?.min_unit_price ?? 0
                        : selectedCategoryDetails?.unit_price ?? 0) * formData.countTicket).toFixed(2))
                }
                onChange={null}
                name="price"
                placeholder=""
                InputProps={{
                  readOnly: true, // Makes the TextField read-only
                }}
                sx={{
                  background: "white",
                  borderRadius: "8px",
                  "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                    padding: "10px",
                  },
                  "& .MuiOutlinedInput-root": {
                    border: "1px solid #5F5F5F",
                    boxShadow: "-2px 2px 4px #00000040",
                    borderRadius: "8px",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>

        {/*<Box className="image-container">*/}
        {/*  <Grid*/}
        {/*    item*/}
        {/*    xs={12}*/}
        {/*    sm={12}*/}
        {/*    md={11}*/}
        {/*    sx={{ paddingInlineStart: "0px !important" }}*/}
        {/*  >*/}
        {/*    /!* Category and Subcategory Details Box *!/*/}

        {/*    /!*<Box*!/*/}
        {/*    /!*  sx={{*!/*/}
        {/*    /!*    border: "1px solid #5F5F5F",*!/*/}
        {/*    /!*    height: "12rem",*!/*/}
        {/*    /!*    display: "flex",*!/*/}
        {/*    /!*    flexDirection: "column",*!/*/}
        {/*    /!*    justifyContent: "space-around",*!/*/}
        {/*    /!*    alignItems: "center",*!/*/}
        {/*    /!*    padding: "14px 100px",*!/*/}
        {/*    /!*    boxShadow: "-2px 2px 4px #00000040",*!/*/}
        {/*    /!*    borderRadius: "8px",*!/*/}
        {/*    /!*    position: "relative",*!/*/}
        {/*    /!*  }}*!/*/}
        {/*    /!*>*!/*/}
        {/*    /!*  <img*!/*/}
        {/*    /!*    src={LeftBlue}*!/*/}
        {/*    /!*    alt="blue"*!/*/}
        {/*    /!*    style={{ position: "absolute", top: "0", left: "0" }}*!/*/}
        {/*    /!*  />*!/*/}
        {/*    /!*  <img*!/*/}
        {/*    /!*    src={LeftOrange}*!/*/}
        {/*    /!*    alt="orange"*!/*/}
        {/*    /!*    style={{ position: "absolute", top: "0", left: "0" }}*!/*/}
        {/*    /!*  />*!/*/}
        {/*    /!*  <img*!/*/}
        {/*    /!*    src={RightBlue}*!/*/}
        {/*    /!*    alt="blue"*!/*/}
        {/*    /!*    style={{ position: "absolute", bottom: "0", right: "0" }}*!/*/}
        {/*    /!*  />*!/*/}
        {/*    /!*  <img*!/*/}
        {/*    /!*    src={RightOrange}*!/*/}
        {/*    /!*    alt="orange"*!/*/}
        {/*    /!*    style={{ position: "absolute", bottom: "0", right: "0" }}*!/*/}
        {/*    /!*  />*!/*/}
        {/*    /!*  {selectedCategoryDetails ? (*!/*/}
        {/*    /!*    // selectedCategoryDetails.picture ? (*!/*/}
        {/*    /!*    //   // Display category image if available*!/*/}
        {/*    /!*    //   <Box*!/*/}
        {/*    /!*    //     sx={{*!/*/}
        {/*    /!*    //       width: "100%",*!/*/}
        {/*    /!*    //       height: "100%",*!/*/}
        {/*    /!*    //       display: "flex",*!/*/}
        {/*    /!*    //       justifyContent: "center",*!/*/}
        {/*    /!*    //       alignItems: "center",*!/*/}
        {/*    /!*    //     }}*!/*/}
        {/*    /!*    //   >*!/*/}
        {/*    /!*    //     <img*!/*/}
        {/*    /!*    //       src={selectedCategoryDetails.picture}*!/*/}
        {/*    /!*    //       alt={selectedCategoryDetails.label}*!/*/}
        {/*    /!*    //       style={{*!/*/}
        {/*    /!*    //         maxWidth: "100%",*!/*/}
        {/*    /!*    //         maxHeight: "100%",*!/*/}
        {/*    /!*    //         objectFit: "contain",*!/*/}
        {/*    /!*    //         borderRadius: "8px",*!/*/}
        {/*    /!*    //       }}*!/*/}
        {/*    /!*    //     />*!/*/}
        {/*    /!*    //   </Box>*!/*/}
        {/*    /!*    // ) : (*!/*/}
        {/*    /!*      <>*!/*/}
        {/*    /!*        <Box*!/*/}
        {/*    /!*          sx={{*!/*/}
        {/*    /!*            display: "flex",*!/*/}
        {/*    /!*            flexDirection: "column",*!/*/}
        {/*    /!*            gap: "10px",*!/*/}
        {/*    /!*            alignItems: "center",*!/*/}
        {/*    /!*          }}*!/*/}
        {/*    /!*        >*!/*/}
        {/*    /!*          <Typography*!/*/}
        {/*    /!*            sx={{*!/*/}
        {/*    /!*              fontWeight: "600",*!/*/}
        {/*    /!*              fontSize: "20px",*!/*/}
        {/*    /!*              lineHeight: "25px",*!/*/}
        {/*    /!*              color: "#3F78E0",*!/*/}
        {/*    /!*            }}*!/*/}
        {/*    /!*          >*!/*/}
        {/*    /!*            {selectedCategoryDetails.label}*!/*/}
        {/*    /!*          </Typography>*!/*/}
        {/*    /!*          <Typography*!/*/}
        {/*    /!*            sx={{*!/*/}
        {/*    /!*              fontWeight: "600",*!/*/}
        {/*    /!*              fontSize: "16px",*!/*/}
        {/*    /!*              lineHeight: "18px",*!/*/}
        {/*    /!*              color: "#5E5B5B",*!/*/}
        {/*    /!*            }}*!/*/}
        {/*    /!*          >*!/*/}
        {/*    /!*            {selectedCategoryDetails.description}*!/*/}
        {/*    /!*          </Typography>*!/*/}
        {/*    /!*        </Box>*!/*/}
        {/*    /!*        <Box*!/*/}
        {/*    /!*          sx={{*!/*/}
        {/*    /!*            display: "flex",*!/*/}
        {/*    /!*            flexDirection: "column",*!/*/}
        {/*    /!*            alignItems: "center",*!/*/}
        {/*    /!*          }}*!/*/}
        {/*    /!*        >*!/*/}
        {/*    /!*          <Typography*!/*/}
        {/*    /!*            sx={{*!/*/}
        {/*    /!*              fontWeight: "500",*!/*/}
        {/*    /!*              fontSize: "20px",*!/*/}
        {/*    /!*              lineHeight: "24px",*!/*/}
        {/*    /!*              background:*!/*/}
        {/*    /!*                "linear-gradient(90deg, #2d5644, #00568E, #B4D1E4, #0064A4, #0083D7)",*!/*/}
        {/*    /!*              WebkitBackgroundClip: "text",*!/*/}
        {/*    /!*              WebkitTextFillColor: "transparent",*!/*/}
        {/*    /!*            }}*!/*/}
        {/*    /!*          >*!/*/}
        {/*    /!*            Price:{" "}*!/*/}
        {/*    /!*            {selectedSubcategoryDetails*!/*/}
        {/*    /!*              ? selectedSubcategoryDetails.price*!/*/}
        {/*    /!*              : "Please Select One of  Sub Categories"}{" "}*!/*/}
        {/*    /!*            $*!/*/}
        {/*    /!*          </Typography>*!/*/}
        {/*    /!*          <svg*!/*/}
        {/*    /!*            width="131"*!/*/}
        {/*    /!*            height="9"*!/*/}
        {/*    /!*            viewBox="0 0 131 9"*!/*/}
        {/*    /!*            fill="none"*!/*/}
        {/*    /!*            xmlns="http://www.w3.org/2000/svg"*!/*/}
        {/*    /!*          >*!/*/}
        {/*    /!*            <path*!/*/}
        {/*    /!*              d="M70.1214 6.5L69.3357 9L68.6214 6.5C68.6214 6.5 68.1214 6.03057 67.1214 6C65.979 5.96508 64.8664 5.96943 64.8664 5.96943L0.522949 4.89515L64.8664 3.54585C64.8664 3.54585 65.7115 3.50932 66.8544 3.45488C67.7869 3.41046 68.6214 3 68.6214 3L69.3357 0L70.1214 3C70.1214 3 70.4925 3.5 71.3421 3.5C72.485 3.5 74.0891 3.55444 74.0891 3.55444L130.694 4.89515L74.2506 5.96133C74.2506 5.96133 72.485 5.96133 71.3421 6C70.5526 6.02671 70.1214 6.5 70.1214 6.5Z"*!/*/}
        {/*    /!*              fill="#ECA601"*!/*/}
        {/*    /!*            />*!/*/}
        {/*    /!*          </svg>*!/*/}
        {/*    /!*        </Box>*!/*/}
        {/*    /!*      </>*!/*/}
        {/*    /!*    // )*!/*/}
        {/*    /!*  ) : (*!/*/}
        {/*    /!*    <>*!/*/}
        {/*    /!*      <Box*!/*/}
        {/*    /!*        sx={{*!/*/}
        {/*    /!*          display: "flex",*!/*/}
        {/*    /!*          flexDirection: "column",*!/*/}
        {/*    /!*          gap: "10px",*!/*/}
        {/*    /!*        }}*!/*/}
        {/*    /!*      >*!/*/}
        {/*    /!*        <Typography*!/*/}
        {/*    /!*          sx={{*!/*/}
        {/*    /!*            fontWeight: "500",*!/*/}
        {/*    /!*            fontSize: "20px",*!/*/}
        {/*    /!*            lineHeight: "25px",*!/*/}
        {/*    /!*            color: "#989898",*!/*/}
        {/*    /!*          }}*!/*/}
        {/*    /!*        >*!/*/}
        {/*    /!*          Service title*!/*/}
        {/*    /!*        </Typography>*!/*/}
        {/*    /!*        <Typography*!/*/}
        {/*    /!*          sx={{*!/*/}
        {/*    /!*            fontWeight: "400",*!/*/}
        {/*    /!*            fontSize: "14px",*!/*/}
        {/*    /!*            lineHeight: "18px",*!/*/}
        {/*    /!*            color: "#989898",*!/*/}
        {/*    /!*          }}*!/*/}
        {/*    /!*        >*!/*/}
        {/*    /!*          Detailed discription about the services and how it works*!/*/}
        {/*    /!*        </Typography>*!/*/}
        {/*    /!*      </Box>*!/*/}
        {/*    /!*      <Box>*!/*/}
        {/*    /!*        <Typography*!/*/}
        {/*    /!*          sx={{*!/*/}
        {/*    /!*            fontWeight: "500",*!/*/}
        {/*    /!*            fontSize: "20px",*!/*/}
        {/*    /!*            lineHeight: "24px",*!/*/}
        {/*    /!*            color: "#989898",*!/*/}
        {/*    /!*          }}*!/*/}
        {/*    /!*        >*!/*/}
        {/*    /!*          Price: XXX $*!/*/}
        {/*    /!*        </Typography>*!/*/}
        {/*    /!*      </Box>*!/*/}
        {/*    /!*    </>*!/*/}
        {/*    /!*  )}*!/*/}
        {/*    /!*</Box>*!/*/}
        {/*  </Grid>*/}
        {/*</Box>*/}
      </Box>
    </Styles>
  );
};

export default MainData;
